import { render, staticRenderFns } from "./DealerLogin.vue?vue&type=template&id=4313858a&scoped=true&"
import script from "./DealerLogin.vue?vue&type=script&lang=js&"
export * from "./DealerLogin.vue?vue&type=script&lang=js&"
import style0 from "./DealerLogin.vue?vue&type=style&index=0&id=4313858a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4313858a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VSelect,VTextField})
